import { Link } from "react-router-dom";
import CTA from "./CTA";
import { motion } from "framer-motion";

function BannerHome({ reference }) {
  return (
    <div
      className="pt-[300px] pb-[100px] relative bg-black overflow-hidden min-h-[700px] bg-no-repeat"
      ref={reference}
    >
      <motion.div
        className="relative z-10 text-left pr-[20px] sm:pr-[100px] ml-[40px] sm:ml-20 p-0"
        initial={{
          opacity: 0,
          x: -50,
        }}
        whileInView={{
          opacity: 1,
          x: 0,
          transition: {
            duration: 1,
          },
        }}
        viewport={{ once: true }}
      >
        <h1 className="mb-12 font-medium text-[9vw] sm:text-[60px] text-white">
          North American Institute of Swiss Watchmaking
        </h1>

        <p className="text-white max-w-[700px] my-0 ml-0 mb-8">
          Learn the Artistry of Horology and Earn an Education Like No Other
        </p>
        <Link
          to="/apply"
          className="uppercase w-max p-4 px-12 text-sm font-medium bg-transparent border-2 border-white text-white hover:text-[#2B3F4B] hover:bg-white transition-colors duration-500"
          aria-label="link to apply"
        >
          Apply Now
        </Link>
      </motion.div>
      <div className="banner-img"></div>
    </div>
  );
}

export default BannerHome;
